import { Button } from '@/components/ui/button'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { Loader2, Play } from 'lucide-react'
import type { VersionedLevelLabels } from './types'

interface ActivateConfirmDialogProps {
  versionNumber: number
  isPending: boolean
  labels: VersionedLevelLabels
  cancelLabel: string
  onConfirm: () => void
  onCancel: () => void
}

export function ActivateConfirmDialog({
  versionNumber,
  isPending,
  labels,
  cancelLabel,
  onConfirm,
  onCancel,
}: ActivateConfirmDialogProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="fixed inset-0 bg-black/50" onClick={onCancel} />
      <Card className="relative z-10 mx-4 w-full max-w-sm">
        <CardHeader>
          <CardTitle>{labels.activate}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">{labels.activateConfirm}</p>
          <div className="flex justify-end gap-2">
            <Button variant="outline" onClick={onCancel} disabled={isPending}>
              {cancelLabel}
            </Button>
            <Button onClick={onConfirm} disabled={isPending}>
              {isPending ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  {labels.activate}
                </>
              ) : (
                <>
                  <Play className="mr-2 h-4 w-4" />
                  {labels.versionLabel(versionNumber)} — {labels.activate}
                </>
              )}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
